import { SxProps, Theme } from "@mui/material";

export const fareharborCheckoutStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.9)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  header: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: "14px 16px",
    position: "relative",
  },
  businessName: (showBack: string | null) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: "1px solid #D6D6DA",
    // width: showBack ? "90%" : "fit-content",
    width: "fit-content",
    cursor: "pointer",
    textAlign: "center",
  }),
  businessText: (theme: Theme, showBack: string | null) => ({
    fontSize: 22,
    fontWeight: 600,
    fontFamily: theme.typography.fontFamily,
    color: "#000",
    // width: showBack ? "90%" : "fit-content",
    width: "fit-content",
  }),
  viewMoreText: (theme: Theme) => ({
    fontSize: 11,
    fontWeight: 400,
    color: "#8D8D8D",
    cursor: "pointer",
    marginTop: "-4px",
    fontFamily: theme.typography.fontFamily,
  }),
  carouselImageContainer: {
    position: "relative",
    width: "100%",
    height: "240px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
  },
  carouselImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "inherit",
  },
  locationTag: (theme: Theme): SxProps<Theme> => ({
    position: "absolute",
    bottom: "30px",
    right: "10px",
    backgroundColor: "#328734",
    color: "#fff",
    padding: "4px 10px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    fontSize: "11px",
    fontWeight: "700",
    fontFamily: theme.typography.fontFamily,
  }),
  locationImage: {
    width: "12px",
    height: "14px",
    marginRight: "6px",
  },
  detailsContainer: {
    maxWidth: "680px",
  },
  detailsHeaderBox: {
    mx: 2,
    mb: 0.5,
  },

  title: (theme: Theme): SxProps<Theme> => ({
    fontSize: 24,
    mt: 1.5,
    textAlign: "center",
    fontWeight: 700,
    color: "#0D0D0D",
    fontFamily: theme.typography.fontFamily,
    lineHeight: "34px",
    letterSpacing: "0.089px",
  }),
  subtitle: (theme: Theme): SxProps<Theme> => ({
    fontSize: 13,
    textAlign: "center",
    fontWeight: 400,
    color: "#0D0D0D",
    marginTop: "-2px",
    fontFamily: theme.typography.fontFamily,
  }),

  divider: {
    borderBottom: "1px solid #D6D6DA",
    mx: 2,
  },
  detailsBox: {
    mx: 2,
    pb: 2,
  },
  descriptionContainer: {
    mt: 2,
  },
  collapsibleTextDesc: {
    fontSize: "13px",
    color: "#333",
  },
  collapsibleSeeMoreDesc: {
    color: "#000",
  },
  descriptionHeader: (theme: Theme): SxProps<Theme> => ({
    fontSize: 17,
    fontWeight: 600,
    fontFamily: theme.typography.fontFamily,
  }),

  dateAndTimeContainer: {
    mt: 2,
    backgroundColor: "#E8E8EB",
    boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)",
    borderRadius: "12px",
    padding: "16px",
  },
  customerTypeContainer: {
    mt: 2,
  },
  customerTypeHeader: (theme: Theme): SxProps<Theme> => ({
    fontWeight: 500,
    fontSize: 20,
    fontFamily: theme.typography.fontFamily,
  }),
  additionalOptionsContainer: {
    mt: 5,
  },
  additionalOptionsHeader: (theme: Theme): SxProps<Theme> => ({
    fontWeight: 700,
    fontSize: 24,
    mt: 2,
    mb: 0.1,
    fontFamily: theme.typography.fontFamily,
  }),
  cancellationPolicyContainer: {
    backgroundColor: "#595959",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    marginTop: 6,
    padding: "12px 16px",
  },
  cancellationHeader: {
    display: "flex",
    flexDirection: "row",
  },
  cancellationIcon: {
    marginRight: "8px",
    width: "28px",
    height: "28px",
  },
  cancellationPolicyTitle: (theme: Theme) => ({
    fontSize: "22px",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    color: "#FFF",
  }),
  collapsibleTextCanc: {
    fontSize: "15px !important",
    fontWeight: 400,
    color: "#FFF",
  },
  collapsibleSeeMoreCanc: {
    color: "#fff",
  },
  customerInformationContainer: {
    mt: 5.5,
    mb: 3,
  },
  customerInformationHeader: (theme: Theme): SxProps<Theme> => ({
    fontSize: 22,
    mb: 0.2,
    fontWeight: 600,
    fontFamily: theme.typography.fontFamily,
  }),

  customerInformationSubHeader: (theme: Theme): SxProps<Theme> => ({
    fontSize: 15,
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily,
    color: "#595959",
    mb: 2,
  }),

  bookNowButton: {
    borderRadius: "8px",
    padding: "12px 24px",
    backgroundColor: "#328734",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },

  fireIcon: {
    marginRight: "8px",
    width: 13,
    height: 17,
  },
  bookNowText: {
    color: "#fff",
    fontSize: 17,
    fontWeight: 600,
  },

  priceContainer: {
    display: "flex",
    flexDirection: "column",
  },
  priceValue: (theme: Theme): SxProps<Theme> => ({
    fontSize: 22,
    fontWeight: 600,
    fontFamily: theme.typography.fontFamily,
  }),
  priceFee: (theme: Theme): SxProps<Theme> => ({
    fontSize: 13,
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily,
    color: "#0D0D0D",
  }),

  userAvatar: {
    width: "34px",
    height: "34px",
    objectFit: "fill",
    borderRadius: "20px",
  },
  userNameText: (theme: Theme): SxProps<Theme> => ({
    fontWeight: 400,
    fontSize: 17,
    mb: 0.5,
    fontFamily: theme.typography.fontFamily,
  }),
  outerMarginContainer: {
    mx: 2,
  },
  referredByContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    mt: 1.25,
    mb: 1.25,
  },
  referredByText: (theme: Theme): SxProps<Theme> => ({
    fontWeight: 600,
    fontSize: 22,
    mb: 1,
    fontFamily: theme.typography.fontFamily,
  }),
  poweredByContainer: {
    my: 2,
  },
  poweredByText: {
    textAlign: "center",
    fontSize: "13px",
    fontWeight: 400,
    color: "#000",
    lineHeight: "18.5px",
    letterSpacing: "0.203px",
  },
  logoImageContainer: {
    display: "flex",
    justifyContent: "center",
  },
  logoImage: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "80px",
    height: "17px",
  },
  footer: {
    position: "sticky",
    width: "100%",
    mx: "auto",
    paddingBottom: "15px",
    bottom: "0",
    paddingTop: "16px",
    borderTop: 1,
    borderColor: "#8D8D8D",
    backgroundColor: "#fff",
  },
  footerInner: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 15px",
  },
};
